// extracted by mini-css-extract-plugin
module.exports = {"s4f6bxv":"s4f6bxv"};